export default "__VITE_ASSET__d7f44604__"